/**
 * @file Full screen loading component.
 */

import React from 'react';

import { getAsset } from '../../util/assets';

const FullScreenLoader = () => (
  <div className="full-screen-loader">
    <img
      className="full-screen-loading-icon"
      src={getAsset('/waldo-icon.svg')}
      alt=""
    />
  </div>
);

export default FullScreenLoader;
